function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x01.03.-Studenta-port\\u0101ls---Pieejams-teorijas-eks\\u0101mens---Izv\\u0113l\\u0113ties-dienu-un-laiku---Forma",
  transform: "translate(-770.000000, -105.000000)",
  fill: "#079DC1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(383.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Next-session",
  transform: "translate(367.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(20.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,3 C11.5522847,3 12,3.44771525 12,4 C12,4.51283584 11.6139598,4.93550716 11.1166211,4.99327227 L11,5 L4,5 C3.48716416,5 3.06449284,5.38604019 3.00672773,5.88337887 L3,6 L3,20 C3,20.5128358 3.38604019,20.9355072 3.88337887,20.9932723 L4,21 L18,21 C18.5128358,21 18.9355072,20.6139598 18.9932723,20.1166211 L19,20 L19,13 C19,12.4477153 19.4477153,12 20,12 C20.5128358,12 20.9355072,12.3860402 20.9932723,12.8833789 L21,13 L21,20 C21,21.5976809 19.75108,22.9036609 18.1762728,22.9949073 L18,23 L4,23 C2.40231912,23 1.09633912,21.75108 1.00509269,20.1762728 L1,20 L1,6 C1,4.40231912 2.24891996,3.09633912 3.82372721,3.00509269 L4,3 L11,3 Z M17.7026847,1.90887557 C18.9145189,0.697041457 20.8792902,0.697041478 22.0911244,1.90887562 C23.2563495,3.07410076 23.3011659,4.93545866 22.2255735,6.15423251 L22.0911244,6.29731529 L12.6727416,15.7156981 C12.5766225,15.8118172 12.4622666,15.8869888 12.3369167,15.937112 L12.2081705,15.9787338 L8.24253563,16.9701425 C7.54677418,17.1440829 6.91327413,16.5540679 7.0086447,15.8667068 L7.0298575,15.7574644 L8.02126621,11.7918295 C8.0542348,11.6599552 8.11361876,11.5366604 8.19531721,11.4291882 L8.28430193,11.3272584 L17.7026847,1.90887557 Z M20.6769108,3.32308918 C20.2768956,2.92307401 19.6460956,2.89450149 19.2131112,3.23737162 L19.1168983,3.32308915 L9.894,12.545 L9.374,14.625 L11.454,14.105 L20.6769108,4.88310174 C21.0461556,4.51385696 21.0989048,3.94796708 20.8351586,3.52253799 L20.7626284,3.41930207 L20.6769108,3.32308918 Z",
  id: "icon"
})))))));

function SvgIcApplyBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "091F2AB8-9631-49F9-9461-9D67D6D9D2FE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApplyBlue);
export default __webpack_public_path__ + "static/media/ic-apply-blue.35010082.svg";
export { ForwardRef as ReactComponent };